<template>
  <div class="home-promotion">
    <!--    <article class="home-promotion-subscribe">-->
    <!--      <h1>Subscribe Now!</h1>-->
    <!--      <ul>-->
    <!--        <li>Get everything so far and more!</li>-->
    <!--        <li>Upgrade from Lite to Premium-->
    <!--          at any time-->
    <!--        </li>-->
    <!--      </ul>-->
    <!--    </article>-->

    <article class="home-promotion-lite-container">
      <aside class="home-promotion-lite-a">
        <section class="home-promotion-lite-title">

          <div class="text-section">
            <span>
              <h1>{{ $t('seedr-title') }}</h1>
              <s-button class="s-button-upgrade lite" iconImage="SVG/plan_lite_logo_SVG.svg">{{ $t('plans.lite-title') }}</s-button>
            </span>
            <br>
            <span class="subtitle" >{{ $t('lite-promotion.available-title') }}</span>
          </div>
        </section>

        <section class="home-promotion-lite-points">
          <div class="list-item">
            <img class="icon" src="~@/assets/images/icon_file.svg" alt="">
            <span>{{ $t('lite-promotion.management-title')}}</span>
          </div>

          <div class="list-item">
            <img class="icon" src="~@/assets/images/icon_tranfers.svg" alt="">
            <span>{{ $t('lite-promotion.transfers-title')}}</span>
          </div>

          <div class="list-item">
            <img class="icon" src="~@/assets/images/icon_cloud.svg" alt="">
            <span>{{ $t('lite-promotion.sync-title')}}</span>
          </div>

          <div class="list-item">
            <img class="icon" src="~@/assets/images/icon_search.svg" alt="">
            <span>{{ $t('lite-promotion.find-title')}}</span>
          </div>
          <!--          <ul>-->
          <!--            <li>Ideal for file managemet</li>-->
          <!--            <li>Downloads and Uploads</li>-->
          <!--            <li>Sync your cloud sources</li>-->
          <!--            <li>Find your files</li>-->
          <!--          </ul>-->
        </section>

        <section class="home-promotion-link ">
          <a href="/pricing#promotion-lite" class="link-b"><span>{{ $t('actions.learn-more') }}</span></a>
        </section>
      </aside>

      <CardPlanBase
        class="card-plan-base"
        :planName="$t('plans.lite-title')"
        price="3"
        btn="button-primary-blue"
        btnLink="/payment"
        :msg="$t('actions.go-lite')"
      />

    </article>
  </div>
</template>

<script>

import CardPlanBase from '@/components/CardPlanBase.vue'
import SButton from '@/components/SButton.vue'


export default {
  name: 'HomePromotion',
  components: {
    CardPlanBase,
    SButton
  },

  props: {
    msg: String
  }
}
</script>
